import { render, staticRenderFns } from "./kb-article.vue?vue&type=template&id=fdb07c78&scoped=true&"
import script from "./kb-article.vue?vue&type=script&lang=js&"
export * from "./kb-article.vue?vue&type=script&lang=js&"
import style0 from "./kb-article.vue?vue&type=style&index=0&id=fdb07c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb07c78",
  null
  
)

export default component.exports